import { InputGroup, Input, FlexboxGrid, Icon, Button } from 'rsuite';
import styles from './DetailingPanelHeader.module.scss';
import iconChevronDown from '../../../../../../assets/icons/icon_chevron_down-blue.svg';
import iconChevronUp from '../../../../../../assets/icons/icon_chevron_up-blue.svg';
import { DetailsResponseItem } from '../../types';
import { formatNumberWithThousandsSeparator, formatPercent, setDiffPercentageText } from '../../utils';

type DetailingPanelHeaderProps = {
  hasOpen: boolean;
  data: DetailsResponseItem;
  onClick: () => void;
  onSearch: (value: string) => void;
};

export const DetailingPanelHeader = ({ onClick, hasOpen, onSearch, data }: DetailingPanelHeaderProps) => (
  <FlexboxGrid align="middle" className={styles['panel-header-content']}>
    {/* REDE */}
    <FlexboxGrid.Item colspan={9} className={styles['chain-section']}>
      <FlexboxGrid align="middle">
        <FlexboxGrid.Item colspan={hasOpen ? 11 : 20} className={styles['table-item']}>
          <p className={styles['detailing-panel-title']}>{data?.cabecalho?.rede}</p>
        </FlexboxGrid.Item>
        {hasOpen ? (
          <FlexboxGrid.Item colspan={13} className={styles['table-item']}>
            <InputGroup inside>
              <InputGroup.Addon>
                <Icon icon="search" style={{ color: '#1473E6' }} />
              </InputGroup.Addon>
              <Input className={styles['input-search']} onChange={onSearch} />
            </InputGroup>
          </FlexboxGrid.Item>
        ) : null}
      </FlexboxGrid>
    </FlexboxGrid.Item>
    {/* PRODUTOS COMPARADOS */}
    <FlexboxGrid.Item colspan={5} className={styles['products-section']}>
      <FlexboxGrid align="middle">
        <FlexboxGrid.Item colspan={24}>
          <p className={styles['detailing-panel-title']}>{formatNumberWithThousandsSeparator(data?.cabecalho?.produtosComparados)} produtos comparados</p>
          <FlexboxGrid align="middle">
            <Button className={styles['expand-button']} onClick={onClick}>
              <img src={hasOpen ? iconChevronUp : iconChevronDown} alt="" className={styles['icon-chevron-down']} />
              {hasOpen ? 'Fechar' : 'Expandir'}
            </Button>
          </FlexboxGrid>
        </FlexboxGrid.Item>
      </FlexboxGrid>
    </FlexboxGrid.Item>
    {/* SITES PRÓPRIOS */}
    <FlexboxGrid.Item colspan={5} className={styles['numbers-section']}>
      <FlexboxGrid align="middle">
        <FlexboxGrid.Item colspan={8} className={styles['table-item']}>
          <p className={styles['big-number-percentage']}>{formatPercent(data?.cabecalho?.sitesProprios?.percentual.total)}</p>
        </FlexboxGrid.Item>
        <FlexboxGrid.Item colspan={16} className={styles['phrase-wrapper']}>
          <p className={styles['reference-light-text']}>
            Está <span className={styles['small-number-percentage']}>{formatPercent(data?.cabecalho?.sitesProprios?.percentual.diff)}</span>{' '}
            <span className={styles['bold-text']}>{setDiffPercentageText(data?.cabecalho?.sitesProprios?.percentual.total)}</span>
          </p>
          <p className={styles['reference-light-bottom-text']}>do que o canal físico</p>
        </FlexboxGrid.Item>
      </FlexboxGrid>
    </FlexboxGrid.Item>
    {/* APPS DE ENTREGA */}
    <FlexboxGrid.Item colspan={5} className={styles['numbers-section']}>
      <FlexboxGrid align="middle">
        <FlexboxGrid.Item colspan={8} className={styles['table-item']}>
          <p className={styles['big-number-percentage']}>{formatPercent(data?.cabecalho?.appsEntrega?.percentual.total)}</p>
        </FlexboxGrid.Item>
        <FlexboxGrid.Item colspan={16} className={styles['phrase-wrapper']}>
          <p className={styles['reference-light-text']}>
            Está <span className={styles['small-number-percentage']}>{formatPercent(data?.cabecalho?.appsEntrega?.percentual.diff)}</span>{' '}
            <span className={styles['bold-text']}>{setDiffPercentageText(data?.cabecalho?.appsEntrega?.percentual.total)}</span>
          </p>
          <p className={styles['reference-light-bottom-text']}>do que o canal físico</p>
        </FlexboxGrid.Item>
      </FlexboxGrid>
    </FlexboxGrid.Item>
  </FlexboxGrid>
);
